import { IQuestionAnswer } from '@ninjacart/nc-nk-core';
import {
  addEventParam,
  INinjaEvent,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import {
  FallBackImage,
  KissanEventType,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import { Image, Paragraph, Text, View, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQnaFeedStore } from '../../store/useQnaStore';
import { isLessThanTenMinutesAgo } from '../../utils/utils';
interface IMyQuestionStatusCard {
  item: IQuestionAnswer;
}

export function MyQuestionStatusCard(props: IMyQuestionStatusCard) {
  const [statusConfig, setStatusConfig] = useState({ timeLeft: -1, width: 0 });
  const removeQuestionActiveTimer = useQnaFeedStore((state) => state.removeQuestionActiveTimer);
  const { t } = useTranslation();
  const { item } = props;
  const userProfile = useProfileStore((state) => state.userProfile);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const handlePopupOpenEvent = () => {
    const qnaAnsweredPopupClickEvent: INinjaEvent = {
      name: KissanEventType.QUESTION_ANSWERED_POPUP_CLICK,
      screenDetails: { screen: 'qna progress bar page' },
      eventParams: [addEventParam('activeIndex',userProfile?.user?.primaryPhoneNumber)],
    };
    enqueue(qnaAnsweredPopupClickEvent);
  };

  useEffect(() => {
    let intervalId;
    handlePopupOpenEvent();
    if (!item) {
      return; // Early return if item or createdAt is undefined
    }

    const timestamp = item.timestamp ?? 0; // Store createdAt for readability
    if (isLessThanTenMinutesAgo(timestamp) === -1) {
      return; // Early return if less than 10 minutes ago
    }

    console.log('Isless than => ', isLessThanTenMinutesAgo(timestamp));

    const updateStatusCardConfig = () => {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - timestamp;
      const progressPercentage = (elapsedTime / (10 * 60 * 1000)) * 100; // 10 minutes in milliseconds
      if (progressPercentage >= 100) {
        removeQuestionActiveTimer(props.item, intervalId);
      }
      setStatusConfig({ timeLeft: isLessThanTenMinutesAgo(timestamp), width: progressPercentage });
    };

    updateStatusCardConfig(); // Initial update

    intervalId = setInterval(updateStatusCardConfig, 1000); // Update every minute

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  // Include item.createdAt in dependency array

  return (
    <>
      {statusConfig.timeLeft === -1 ? (
        <></>
      ) : (
        <YStack>
          <XStack marginBottom={10}>
            <Image
              source={{
                uri:
                  item.medias?.[0]?.type == 'video'
                    ? (item.medias?.[0]?.preview_url ?? FallBackImage)
                    : ((item.medias?.[0]?.url || item?.author?.picture) ?? FallBackImage),
              }}
              width={50}
              height={50}
              borderRadius={10}
            />
            {item?.body && (
              <YStack paddingLeft={10} paddingRight={10} flex={1}>
                <Paragraph
                  ellipsizeMode="tail"
                  numberOfLines={2}
                  fontSize={16}
                  fontWeight={'600'}
                  color={'$color'}
                >
                  <Text color={'$primary'} fontWeight={'600'}>
                    {t('page.question')}:
                  </Text>{' '}
                  {item.body}
                </Paragraph>
              </YStack>
            )}
          </XStack>
          <XStack marginVertical={10} height={6} backgroundColor={'#EEE'} borderRadius={10}>
            <View
              style={{
                backgroundColor: '#368665',
                height: 6,
                width: `${Math.ceil(statusConfig.width)}%`,
                left: '0%',
                borderRadius: 10,
                position: 'relative',
              }}
            ></View>
          </XStack>
          <XStack display="flex" justifyContent="space-between">
            <Paragraph fontSize={13} fontWeight={'500'} color={'$color'}>
              {t('page.yourExpertAnswerIsOnTheWay')}
            </Paragraph>
            <Paragraph fontSize={13} fontWeight={'500'} color={'$grey'}>
              {10 - statusConfig.timeLeft} mins left
            </Paragraph>
          </XStack>
        </YStack>
      )}
    </>
  );
}
